var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "material-info-card" }, [
    _c(
      "div",
      { staticClass: "card-header" },
      [
        _c("div", { staticClass: "card-title" }, [
          !_vm.editingData
            ? _c("div", [
                _c("span", { staticClass: "title-label" }, [
                  _vm._v(
                    _vm._s(_vm.$tc("Code", 1)) +
                      " / " +
                      _vm._s(_vm.$tc("Reference", 1)) +
                      ":"
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "title-reference" }, [
                  _vm._v(_vm._s(_vm.materialReference))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.editingData
            ? _c("span", { staticClass: "title-label" }, [
                _vm._v(_vm._s(_vm.$t(_vm.cardLabel)))
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.showEditButton
          ? _c("custom-button", {
              attrs: {
                icon: "mdi-pencil",
                "icon-size": 13,
                height: "20px",
                width: "20px",
                "button-styling": _vm.buttonStyling
              },
              on: {
                buttonClick: function($event) {
                  return _vm.$emit("toggle-edit")
                }
              }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "card-info",
        style: { "overflow-y": _vm.editingData ? "auto" : "hidden" }
      },
      _vm._l(_vm.fields, function(field) {
        return _c(
          "div",
          {
            key: field.label,
            staticClass: "card-info-item-container",
            style: [
              {
                width: field.size ? field.size : 100 / 3 + "%",
                overflow: _vm.editingData ? "visible" : "hidden"
              }
            ]
          },
          [
            !_vm.editingData
              ? _c("v-icon", [_vm._v(_vm._s(field.icon))])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-info-item", style: _vm.cardInfoItemStyling },
              [
                _vm.editingData
                  ? _c("input-field", {
                      key: field.varName,
                      attrs: {
                        "input-type": field.inputType,
                        value: field.value,
                        label: field.label,
                        "input-disabled": field.disabled,
                        "select-options-list": field.options,
                        "checkbox-options": field.checkboxOptions,
                        min: field.min,
                        max: field.max,
                        step: field.step,
                        size: "large",
                        clearable: field.clearable,
                        required: field.required,
                        inputFieldContainerStyling: { padding: "0" },
                        radioOptions:
                          field.inputType === "radio"
                            ? field.radioOptions
                            : null
                      },
                      on: {
                        input: function($event) {
                          return _vm.updateField($event, field)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.editingData && field.varName !== "sm_reference"
                  ? _c("span", { staticClass: "card-info-item-label" }, [
                      _vm._v(
                        "\n          " + _vm._s(field.label) + ":\n        "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.editingData && _vm.fieldIsBarcodeField(field.label)
                  ? _c("img", {
                      attrs: {
                        src: require("../../assets/barcode.png"),
                        alt: field.value
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.editingData && field.varName !== "sm_reference"
                  ? _c("span", { staticClass: "card-info-item-value" }, [
                      _vm._v(
                        "\n          " + _vm._s(field.value) + "\n        "
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-065ca0d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-065ca0d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/StockManagement/MaterialMainInfo.vue
// module id = null
// module chunks = 